import styled from 'styled-components';
import { BoxButton } from '@riac/design-system';

export const SuggestedContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  ${(props) => props.theme.desktop} {
    flex-wrap: nowrap;
  }
  ${BoxButton} {
    display: flex;
    line-height: 0;
    font-size: 2rem;
    padding: 16px;
    margin: 15px auto;
  }
  div {
    text-align: center;
    p {
      color: ${(props) => props.theme.black[70]};
    }
  }
`;
